import React from "react";
import { UnControlled as CodeMirror } from "react-codemirror2";
import {connect} from 'react-redux';
import { putDataInDevCenterDataStore, getDevCenterDataStore } from '../../../../../app/store';
import {ResizableBox} from 'react-resizable';
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/javascript/javascript.js";
import "react-resizable/css/styles.css";
import $ from 'jquery';
import { isDefaultSite, setDisplayFlexBasedOnId, setJsTreePath } from "../../../../../commons/ui-commons";
import { getPartnerName } from '../../../../../lhs/reducers/configuration-reducer';
import { getMappingJsonFromID } from '../../../../../libs/common-library';


// components
var summary = "";
class CodeEditorContainer extends React.Component {

  isExampleEdited = false;

  state = {
    heightDiv: 443,
  };

  handleKeyDown = (e) => {
    const { heightDiv: heightDiv } = this.state;
    switch(e.keyCode) {
      case 38: // up arrow
        this.setState({ heightDiv: heightDiv - 10 });
        break;
      case 40: // down arrow
        this.setState({ heightDiv: heightDiv + 10 });
        break;
      default:
        break;
    }
  }

  render(){
    // console.log(this.props.exampleValue);
    // const [codeEditorState, setCodeEditorState] = useState();
    const { heightDiv } = this.state;
    var code = this.props.exampleValue;
    var lines = 0;
    if(code){
      lines = (code.match(/\n/g) || '').length + 5;
    }
    var maxHeight = 500;
    if(lines>5){
      maxHeight = lines*20;
    }

    // useEffect(() => {
    //   setCodeEditorState(code);
    // }, [code]);

    const cmOptions = {
      theme: "default",
      background: "#dadde3",
      height: "auto",
      viewportMargin: Infinity,
      mode: {
        name: "javascript",
        json: true,
        statementIndent: 2
      },
      lineNumbers: true,
      lineWrapping: false,
      indentWithTabs: false,
      tabSize: 2,
      autoRefresh: true
    };
    if(summary != this.props.exampleSummary){
      summary = this.props.exampleSummary
      $(".react-resizable").height(443);
      setDisplayFlexBasedOnId("live-console");
    }
    $('.CodeMirror-linenumber').addClass("color_theme_primary");

    var partnerName = getPartnerName();
    if (partnerName !== "cybs" && code && !this.isExampleEdited){       
        var preWLCode = code;     
        code = updateReqFieldValuesBasedOnWLMap(JSON.parse(code), '');
        if(preWLCode !== code) {
          putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_VALUE',exampleValue:code});
        }
    }

    this.isExampleEdited = false;

    return (
      <div id= "request-editor-text"className="panel panel-default" style={{width: '100%'}} tabIndex="0" onKeyDown={this.handleKeyDown}>
        <ResizableBox width={600} height={heightDiv} minConstraints={[550,443]} maxConstraints={[1000,maxHeight]} axis="y">
        <div id="outer-codemirror" aria-label="Code Editor for Sample Request" style={{height: 'inherit'}}>
        <CodeMirror
          value={code}
          options={cmOptions}
          autoCursor={false}
          onKeyUp={(editor)=> {putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_VALUE',exampleValue:editor.getValue()}); this.isExampleEdited = true;}}
          editorDidMount={(editor) => {
            editor.refresh();
          }}
        />
        </div>
        </ResizableBox>
      </div>
    );
  }
  
};

function updateReqFieldValuesBasedOnWLMap(obj, parentKey) {
  var partnerConfigJson = getMappingJsonFromID("partner-config");
  if (partnerConfigJson) {
    var reqFieldWLJson = partnerConfigJson["request-field-wl"];
    if(reqFieldWLJson) {
      Object.keys(obj).forEach((key) => {
        //Replace in key, if string
        if (typeof key === 'string' && typeof obj[key] === 'string' && reqFieldWLJson.hasOwnProperty(key) && !(parentKey === 'account' && key === 'number')) {
          obj[key] = reqFieldWLJson[key];
        }
    
        //if still an object, call recursively
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          updateReqFieldValuesBasedOnWLMap(obj[key], key);
        }
      });
    }
  }
  return JSON.stringify(obj, null, 2);
}

function mapStateToProps(state){  
  if(!isDefaultSite())
  {
    setTimeout(function(){
      $('.CodeMirror-linenumber').addClass('color_theme_primary');
      $('.vds-state--selected').addClass('border_color_theme_primary_bottom');
    },1);
    // setJsTreePath();
    $('.css-1wjqh8f-CSS-CSS-white-bg-bg').css("width","unset !important");
    var color = $('.color_theme_primary').css("color");
    $('use').css('fill',color + " !important");
    //$('use').addClass('color_theme_primary_fill');
    $('.vds-card--content--mini').addClass('border_color_theme_primary_bottom_shadow'); 
    $('.vds-card--content-separator').addClass('bg_color_theme_primary');
    $('.css-31a4rk-white-structPadding').addClass('border_color_theme_primary_left');
    $('.css-br4h6').addClass('border_color_theme_primary_left');
  }
  else  
  {
    $(".css-j1bcvn-itemListStyles ul li").css('background-color', '#202A44 !important');
    $('.api-reference .vds-state--selected').css('border-bottom','3px solid #2defe0 !important');
  }
  return{
    exampleValue: state.examplesReducer.exampleValue,
    exampleSummary: state.examplesReducer.exampleSummary
  }
}

export default connect(mapStateToProps)(CodeEditorContainer);
